<template>
    <div
        class="app-container"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">{{ L("SysOpLogs") }}</h3>
                <span>操作日志</span>
            </el-col>
        </el-row>
        <el-card>
            <el-form :model="fetchParams" label-width="120px" label-position="left">
                <div>
                    <el-row :gutter="20" style="padding-bottom: 15px">
                        <el-col :span="8">
                            <el-form-item label="日期" label-width="80px">
                                <el-date-picker
                                    v-model="time"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    size="mini"
                                    style="width: 100%"
                                    @change="timeChange"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="错误状态" label-width="80px">
                                <el-select
                                    size="mini"
                                    class="width100"
                                    v-model="fetchParams.hasException"
                                >
                                    <el-option
                                        v-for="item in errorState.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-button
                                type
                                size="mini"
                                icon="el-icon-search"
                                class="pull-right"
                                @click="search"
                                >查询</el-button
                            >
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="用户名" label-width="80px">
                                <el-input
                                    size="mini"
                                    placeholder="请输入用户名"
                                    v-model="fetchParams.userName"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="服务名称" label-width="80px">
                                <el-input
                                    size="mini"
                                    placeholder="请输入对应的服务名称"
                                    v-model="fetchParams.serviceName"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="8">
                            <el-form-item label="方法名称" label-width="80px">
                                <el-input
                                    size="mini"
                                    placeholder="请输入对应的方法名称"
                                    v-model="fetchParams.methodName"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>

            <el-table class="data-table" size="mini" :data="tableData" border stripe>
                <el-table-column width="60">
                    <template slot-scope="scope">
                        <i
                            class="fa fa-check-circle text-success"
                            style="font-size: 22px"
                            v-if="!scope.row.exception"
                        ></i>
                        <i
                            class="fa fa-check-circle text-danger"
                            style="font-size: 22px"
                            v-else
                        ></i>
                    </template>
                </el-table-column>
                <el-table-column min-width="160" :label="L('Time')" prop="executionTime" sortable>
                    <template slot-scope="scope">
                        <!-- <i>{{scope.row.executionTime|DateTimeFormat('YYYY-MM-DD HH:mm:ss')}}</i> -->
                        <i>{{ scope.row.executionTimeStr }}</i>
                    </template>
                </el-table-column>
                <el-table-column
                    width="120"
                    prop="userName"
                    :label="L('UserName')"
                    sortable
                ></el-table-column>
                <el-table-column
                    min-width="250"
                    prop="serviceName"
                    :label="L('Service')"
                ></el-table-column>
                <el-table-column
                    min-width="250"
                    prop="methodName"
                    :label="L('Action')"
                ></el-table-column>
                <el-table-column min-width="250" label="请求地址">
                    <template slot-scope="scope">
                        /{{ scope.row.serviceName }}/{{scope.row.methodName}}</i>
                    </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    :label="L('Duration')"
                    prop="executionDuration"
                    sortable
                >
                    <template slot-scope="scope">
                        <i>{{ scope.row.executionDuration }} ms</i>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="clientIpAddress"
                    width="120"
                    :label="L('IpAddress')"
                ></el-table-column>
                <el-table-column
                    prop="clientName"
                    width="100"
                    :label="L('Client')"
                ></el-table-column>
                <el-table-column
                    prop="browserInfo"
                    min-width="260"
                    :label="L('Browser')"
                ></el-table-column>
                <el-table-column width="100" :label="L('Action')" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            size="small"
                            icon="el-icon-search"
                            @click="
                                dialogDetail.isShow = true;
                                dialogDetail.model = scope.row;
                            "
                        ></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagerBar
                ref="refPagerBar"
                :apiURL="DataApi"
                :GetData="getTableData"
                :queryParam="queryParam"
                :isInit="false"
                :errorFunc="errorHandler"
            ></pagerBar>

            <el-dialog
                v-el-drag-dialog
                class="dialog-detail"
                title="操作日志详情"
                :visible.sync="dialogDetail.isShow"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
            >
                <article>
                    <h2>{{ L("UserInformations") }}</h2>
                    <article>
                        <section>
                            <em>{{ L("UserName") }}:</em>
                            {{ dialogDetail.model.userName }}
                        </section>
                        <section>
                            <em>{{ L("IpAddress") }}:</em>
                            {{ dialogDetail.model.clientIpAddress }}
                        </section>
                        <section>
                            <em>{{ L("Client") }}:</em>
                            {{ dialogDetail.model.clientName }}
                        </section>
                        <section>
                            <em>{{ L("Browser") }}:</em>
                            {{ dialogDetail.model.browserInfo }}
                        </section>
                    </article>

                    <h2>{{ L("ActionInformations") }}</h2>
                    <article>
                        <section>
                            <em>{{ L("Service") }}:</em>
                            {{ dialogDetail.model.serviceName }}
                        </section>
                        <section>
                            <em>{{ L("Action") }}:</em>
                            {{ dialogDetail.model.methodName }}
                        </section>
                        <section>
                            <!-- <em>{{L('Time')}}:</em> {{dialogDetail.model.executionTime | DateTimeFormat('YYYY-MM-DD HH:mm:ss')}}</section> -->
                            <em>{{ L("Time") }}:</em>
                            {{ dialogDetail.model.executionTime }}
                        </section>
                        <section>
                            <em>{{ L("Duration") }}:</em>
                            {{ dialogDetail.model.executionDuration }} ms
                        </section>
                        <section>
                            <em>{{ L("Parameters") }}:</em>
                            <pre style ="white-space:pre-wrap" lang="js">{{
                                dialogDetail.model.parameters
                                    ? JSON.stringify(
                                          JSON.parse(dialogDetail.model.parameters),
                                          null,
                                          "\t"
                                      )
                                    : ""
                            }}</pre>
                        </section>
                    </article>

                    <h2>{{ L("CustomData") }}</h2>
                    <article>
                        <section style ="white-space:pre-wrap">{{ dialogDetail.model.customData || L("None") }}</section>
                    </article>

                    <h2>{{ L("ErrorState") }}</h2>
                    <article class="error-status">
                        <section>
                            <i
                                class="fa fa-check-circle text-success"
                                style="font-size: 18px"
                                v-if="!dialogDetail.model.exception"
                            ></i>
                            <span>{{ dialogDetail.model.exception || L("Success") }}</span>
                        </section>
                    </article>
                </article>
                <span slot="footer" class="dialog-footer">
                    <el-button class="waves-effect" @click="dialogDetail.isShow = false">{{
                        L("Close")
                    }}</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
import moment from 'moment'

import axios from 'axios'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    name: 'sysoplogs',

    data() {
        return {
            DataApi: config.BASE_Middle_API + 'SysOpLogs/GetSysOpLogs', //获取源数据接口 需提供
            openloading: false,
            queryParam: {},
            dialogDetail: {
                isShow: false,
                model: {}
            },
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],

            fetchParams: {
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                userName: '',
                serviceName: '',
                methodName: '',
                browserInfo: '',
                hasException: null,
                minExecutionDuration: null,
                maxExecutionDuration: null,
                sorting: '',
                maxResultCount: config.defaultPageSize,
                skipCount: 0
            },
            errorState: {
                options: [
                    {
                        value: null,
                        label: this.L('All')
                    },
                    {
                        value: false,
                        label: 'Success'
                    },
                    {
                        value: true,
                        label: 'HasError'
                    }
                ],
                value: null,
                label: this.L('All')
            },
            loading: false,
            tableData: [] //表格数据
        }
    },
    components: {
        pagerBar
    },
    methods: {
        timeChange(val) {
            this.fetchParams.startDate = moment(val[0]).format('YYYY-MM-DD')
            this.fetchParams.endDate = moment(val[1]).format('YYYY-MM-DD')
        },
        errorHandler() {
            this.openloading = false
        },
        search() {
            this.openloading = true
            this.queryParam = Object.assign({}, this.fetchParams)
        },

        getTableData(d) {
            this.tableData = d
            this.openloading = false
        },
        Refresh() {
            //刷新table数据
            this.isShow = false
            this.$refs.refPagerBar.Refresh()
        }
    }
}
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
.el-card {
    height: calc(100vh - 217px) !important;
}
</style>
